// extracted by mini-css-extract-plugin
export default {"dataItemWrapper":"styles_dataItemWrapper__Y8sSf","titleWrapper":"styles_titleWrapper__7XrWG","tagsWrapper":"styles_tagsWrapper__jPAis"};